import React from 'react';
import { connect } from 'react-redux';
import {
    isOfflineReady,
    isConnected,
    selectConnectedAt,
} from '../selectors/offline';
import { routeToApplications } from '../actions/route';
import OfflineMenu from './offline_menu.ui.jsx';
import { swEnabled } from '../engage_cache.js';

let Component = () => <noscript />;

if (swEnabled) {
    Component = connect(
        state => {
            return {
                swEnabled: swEnabled && isOfflineReady(state),
                isOfflineReady: isOfflineReady(state),
                disconnectedAt:
                    swEnabled &&
                    !isConnected(state) &&
                    selectConnectedAt(state),
            };
        },
        { routeToApplications }
    )(OfflineMenu);
}

export default Component;



// WEBPACK FOOTER //
// ./src/components/offline_menu.jsx